var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('div',{staticClass:"w-full"},[(_vm.menuOfficialSignature?.canRead)?_c('CDD'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }